import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { untilDestroy } from '@tokeet-frontend/tv3-platform'
import { DocumentsPrefForm } from '@tv3/containers/documents/preferences/form/documents-pref-form'
import { AutomationWizardSaveAction, AutomationWizardCloseAction } from '../../automations-wizard.actions'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-document-notifications-pref-list',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  templateUrl: './document-notifications-pref-list.component.html',
})
export class DocumentNotificationsPrefListComponent extends DocumentsPrefForm {
  @Input() notifyType: 'signer' | 'user' = 'signer'

  constructor(
    protected fb: UntypedFormBuilder,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    private actions: Actions
  ) {
    super(fb, store, amplitudeService)
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.actions.pipe(ofType(AutomationWizardSaveAction), untilDestroy(this)).subscribe((action) => {
      this.save()
      if (action.closeAfterSave) {
        this.store.dispatch(AutomationWizardCloseAction())
      }
    })
  }
}
